/*
  Screen-reader and keyboard support for the bag slideout (<cart-slideout>).

  minicart.*.min.js (built from source that isn't in the theme) opens and
  closes the panel by toggling the translate-x-full class and handles Escape.
  This adds, on top of it:
  - dialog semantics, labelled by the "Bag" heading
  - the closed panel is inert, so its off-screen controls aren't in the tab order
  - focus moves to the close button when it opens, and back to whatever
    opened it (bag icon, add to cart) when it closes
*/
(function () {
  function init(panel) {
    if (panel.dataset.a11yReady) return;
    panel.dataset.a11yReady = 'true';

    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    if (document.getElementById('CartSlideoutTitle')) panel.setAttribute('aria-labelledby', 'CartSlideoutTitle');

    let opener = null;
    const isOpen = () => !panel.classList.contains('translate-x-full');

    const sync = () => {
      if (isOpen()) {
        if (panel.hasAttribute('inert')) {
          panel.removeAttribute('inert');
          if (!panel.contains(document.activeElement) && document.activeElement !== document.body) opener = document.activeElement;
          const close = panel.querySelector('[data-cart-close]');
          if (close) close.focus({ preventScroll: true });
        }
      } else if (!panel.hasAttribute('inert')) {
        const hadFocus = panel.contains(document.activeElement);
        panel.setAttribute('inert', '');
        if (hadFocus && opener && document.contains(opener)) opener.focus({ preventScroll: true });
        opener = null;
      }
    };

    // Add to cart re-renders the panel and the new one can arrive already open:
    // start it inert so sync() treats that as an open and moves focus in.
    panel.setAttribute('inert', '');
    sync();
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  const run = () => document.querySelectorAll('[data-cart-slideout]:not([data-a11y-ready])').forEach(init);
  customElements.whenDefined('cart-slideout').then(run);
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  // Pick up panels swapped in by the cart's section re-render
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
